import { useTheme } from "@hooks/useTheme";

const CustomTextarea = ({
  value,
  onChange,
  placeholder,
  className,
  size = "md",
  disabled = false,
  readOnly = false,
  onClick,
  style,
  onFocus,
  onBlur,
  rows = 2,
  resize = "vertical",
  maxLength,
  showCounter = false,
  ...props
}) => {
  const { colors } = useTheme();

  // Size configurations
  const sizeConfigs = {
    xs: {
      fontSize: "0.75rem",
      padding: "0.25rem 0.5rem",
      borderRadius: "0.25rem",
      minHeight: "3rem",
    },
    sm: {
      fontSize: "0.875rem",
      padding: "0.375rem 0.625rem",
      borderRadius: "0.5rem",
      minHeight: "4rem",
    },
    md: {
      fontSize: "0.875rem",
      padding: "0.5rem 0.75rem",
      borderRadius: "0.5rem",
      minHeight: "5rem",
    },
    lg: {
      fontSize: "1.125rem",
      padding: "0.625rem 1rem",
      borderRadius: "0.5rem",
      minHeight: "6rem",
    },
    xl: {
      fontSize: "1.25rem",
      padding: "0.75rem 1.25rem",
      borderRadius: "0.75rem",
      minHeight: "7rem",
    },
  };

  const currentSize = sizeConfigs[size] || sizeConfigs.md;

  const baseClasses = [
    "w-full border focus:outline-none transition-colors",
    colors.borderPrimary,
    colors.bgInput,
    colors.textPrimary,
    disabled ? "opacity-50 cursor-not-allowed" : "",
    readOnly && onClick ? "cursor-pointer" : "",
    className || "",
  ]
    .filter(Boolean)
    .join(" ");

  const textareaStyles = {
    fontSize: currentSize.fontSize,
    padding: currentSize.padding,
    borderRadius: currentSize.borderRadius,
    // minHeight: rows > 1 ? currentSize.minHeight : undefined,
    resize: resize,
    ...style,
  };

  // Handle focus border color via CSS-in-JS
  const handleFocus = (e) => {
    e.target.style.borderColor = colors.borderActiveColor;
    if (onFocus) onFocus(e);
  };

  const handleBlur = (e) => {
    e.target.style.borderColor = '';
    if (onBlur) onBlur(e);
  };

  return (
    <div className="w-full">
      <textarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        onClick={onClick}
        rows={rows}
        className={baseClasses}
        style={textareaStyles}
        onFocus={handleFocus}
        onBlur={handleBlur}
        maxLength={maxLength}
        {...props}
      />
      {maxLength && showCounter && (
        <div className={`text-xs mt-1 ${colors.textSecondary} text-left`}>
          {value.length}/{maxLength}
        </div>
      )}
    </div>
  );
};

export default CustomTextarea; 